// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1aOJ6","question":"styles_question__3pU5E","description":"styles_description__37OWl"};